import type { Styles } from 'common/types';

export const styles: Styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    mt: 2,
  },
  textAreasRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
  },
  textAreaWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  sectionTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: 'text.primary',
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    alignItems: 'stretch',
  },
  cardItem: {
    width: {
      xs: '100%',
      sm: 'calc(50% - 8px)',
      md: 'calc(33.333% - 11px)',
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    p: 2,
    borderRadius: '12px',
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: 'primary.light',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    },
  },
  cardItemDragOver: {
    borderStyle: 'dashed',
    borderColor: 'primary.main',
    backgroundColor: 'primary.50',
    opacity: 0.8,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 0.5,
  },
  dragHandle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    color: 'action.active',
    '&:active': { cursor: 'grabbing' },
  },
  deleteAction: {
    backgroundColor: 'error.50',
    color: 'error.main',
    width: 28,
    height: 28,
    '&:hover': {
      backgroundColor: 'error.100',
    },
  },
  charCount: {
    position: 'absolute',
    bottom: -20,
    right: 4,
    fontSize: '0.75rem',
  },
  charCountSmall: {
    position: 'absolute',
    bottom: -18,
    right: 4,
    fontSize: '0.65rem',
  },
  cardItemContent: {
    position: 'relative',
    mb: 2,
  },
  multilineInput: {
    '& .MuiInputBase-root': {
      alignItems: 'flex-start',
      p: 1.5,
    },
    '& textarea': {
      resize: 'none',
      height: '100% !important',
      overflowY: 'auto !important',
      '&::-webkit-scrollbar': { width: '4px' },
      '&::-webkit-scrollbar-track': { background: 'transparent' },
      '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '4px' },
    },
  },
  gridWrapper: {
    position: 'relative',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease-in-out',
  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '80px',
    background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1) 90%)',
    zIndex: 2,
    pointerEvents: 'none',
  },
  expandButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    mt: 1,
  },
  expandButton: {
    textTransform: 'none',
    fontWeight: 600,
    color: 'text.secondary',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 4,
    gap: 1,
    color: 'text.disabled',
    borderRadius: 2,
    border: '1px dashed',
    borderColor: 'divider',
    mb: 2,
  },
};
